export const origin = location.origin;
export const protocol = location.protocol.slice(0, -1);
export const baseUrl = `${origin}`;
export const apiUrl = `${baseUrl}/api`;
export const domain = document.domain;

export { Response, FailureResponse, SuccessResponse } from './axios-helper';
